export const SITE_URL = "https://plush-spa.in";

export const BUSINESS = {
  name: "Plush Spa",
  shortName: "Plush",
  tagline: "Sink Into Velvet Stillness",
  phone: "+91 97010 03813",
  phoneClean: "+919701003813",
  phoneDisplay: "+91 97010 03813",
  address:
    "Metro Station, 16-11-20/7/H/2,5,6, Hymavathi Heights, 1st Floor, above Old Mumbai Ice Cream, beside Moosarambagh, Saleem Nagar Colony, Malakpet, Hyderabad, Telangana 500036",
  addressShort: "Malakpet, Hyderabad, Telangana 500036",
  landmark: "Above Old Mumbai Ice Cream, beside Moosarambagh, near Malakpet Metro Station",
  city: "Hyderabad",
  website: SITE_URL + "/",
  mapsEmbedSrc:
    "https://www.google.com/maps?q=Hymavathi+Heights+Saleem+Nagar+Colony+Malakpet+Hyderabad+Telangana+500036&output=embed",
  mapsDirectionsUrl:
    "https://www.google.com/maps/search/?api=1&query=" +
    encodeURIComponent(
      "Hymavathi Heights, 16-11-20/7/H/2,5,6, Saleem Nagar Colony, Malakpet, Hyderabad, Telangana 500036"
    ),
};
